import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { callReorderItem } from '../../actions/CallReorderItem';
import { reorderItem } from '../../actions/ReorderItem';

import { addContentFavorite, removeContentFavorite } from '../../actions/spaces/FavoritesActions';
import { getContentDetail } from '../../actions/spaces/GetContentDetailAction';
import { siteUrlsSelector } from '../../selectors/SiteUrlsSelectors';
import { selectSpaceInfo } from '../../selectors/SpaceInfoSelectors';
import { AppState } from '../../state/AppState';
import {
  isSingleCollectionSpace,
  isDatasourceConnectionSubSpace,
  isFavoritesSpace,
  isProjectSpace,
  isRecentsSpace,
  IsWorkbookDatasourceSubspaceTab,
  SpaceInfo,
  isPersonalSpace
} from '../../state/SpaceInfo';
import { MapDispatchToProps, MapStateToProps } from '../../utils/ConnectUtils';
import { ContentCardWrapper, ContentCardWrapperDispatchProps, ContentCardWrapperOwnProps, ContentCardWrapperStateProps } from './ContentCardWrapper';
import { FeatureFlags } from '../../../ts/FeatureFlags';

const mapStateToProps: MapStateToProps<ContentCardWrapperStateProps> = (state: AppState, ownProps: ContentCardWrapperOwnProps) => {
  const spaceInfo: SpaceInfo = selectSpaceInfo(state);
  return {
    urls: siteUrlsSelector(state),
    inWorkbookDatasourcesSubspace: IsWorkbookDatasourceSubspaceTab(spaceInfo),
    inDatasourceConnectionsSubspace: isDatasourceConnectionSubSpace(spaceInfo),
    inProjectSpace: isProjectSpace(spaceInfo),
    inRecentsSpace: isRecentsSpace(spaceInfo),
    inCollectionSpace: isSingleCollectionSpace(spaceInfo),
    inPersonalSpace: isPersonalSpace(spaceInfo),
    allowDragAndDrop: isFavoritesSpace(spaceInfo) && FeatureFlags.reorderFavoritesEnabled, // soon collections too!
    spaceInfo: spaceInfo,
    drafts: state.drafts?.drafts,
  };
};

const mapDispatchToProps: MapDispatchToProps<ContentCardWrapperDispatchProps> = (dispatch) => bindActionCreators({
  addContentFavorite: addContentFavorite,
  removeContentFavorite: removeContentFavorite,
  getContentDetail: getContentDetail,
  reorderItem: reorderItem,
  callReorderItem: callReorderItem,
}, dispatch);

export const ConnectedContentCardWrapper: React.ComponentClass<ContentCardWrapperOwnProps> = connect(mapStateToProps, mapDispatchToProps)(ContentCardWrapper);
